import { render, staticRenderFns } from "./TierInput.vue?vue&type=template&id=136ecee7&scoped=true"
import script from "./TierInput.vue?vue&type=script&lang=js"
export * from "./TierInput.vue?vue&type=script&lang=js"
import style0 from "./TierInput.vue?vue&type=style&index=0&id=136ecee7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136ecee7",
  null
  
)

export default component.exports